<template>
  <div
    class="box-view-more"
    :class="{ 'is-open': isOpen }"
  >
    <div class="box-view-more__inner">
      <slot></slot>
    </div>

    <div
      class="box-view-more__button-wrap"
      :class="{ 'is-open': isOpen }"
    >
      <button
        class="box-view-more__button"
        @click="toggleViewBox()"
      >
        <span>{{ getButtonLabel }}</span>
        <i
          class="icon icon-bor-triangle-down text-primary"
          :class="{ 'is-rotate': isOpen }"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxViewMore',
  data() {
    return {
      isOpen: false, // boxの開閉状態
    }
  },
  computed: {
    /**
     * boxの開閉状態によって、適したボタン名を表示
     */
    getButtonLabel() {
      return this.isOpen ? '折りたたむ' : 'もっと見る'
    }
  },
  methods: {
    /**
     * boxの開閉状態を切り替える
     */
    toggleViewBox() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
